import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import edit from "../../../assets/images/edit.png";
import trash from "../../../assets/images/trash.png";
import BellR from "../../../assets/images/bell_de.png";
import BellG from "../../../assets/images/bell_flt.png";
import MailR from "../../../assets/images/mail_dlt.png";
import MailG from "../../../assets/images/mail_at.png";
import Reset from "../../../assets/images/superadmin/reset.png";
import hide from '../../../assets/images/view_show.png';
import Cross from '../../../assets/images/close.png';
import Tick from '../../../assets/images/ck2.png';
import view from '../../../assets/images/view.png';
import Userview from "../../../assets/images/useer_view.png";
import Select from 'react-select';
import { toast } from 'react-toastify';

import { withToken, withRFSToken } from '../../../Services/axios.js';
import { USERDELETE, AIRLINEUSER, AIRLINESTATION, AIRLINESAVEUSER, AIRLINEREMOVEUSER } from '../../../Utils/conts.js';
import { CallApi, CommonModal } from '../../../Components/common/CommonFunctions.js';
import ConfModal from '../../../Components/common/ConfModal.js';

const UserSettings = ({ isModal, ruleId }) => {

  const isMounted = useRef(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalSec, setModalSec] = useState('');
  const [deleteId, setDeleteId] = useState('');
  const [showHide, setShowHide] = useState(false);
  const [modalConf, setModalConf] = useState(false);
  const [deleteFunction, setDeleteFunction] = useState(null);
  const userRole = [
    { label: 'User', value: 'E' },
    { label: 'Admin', value: 'S' },
    // {label: 'Company Super Admin', value: 'SA'}
  ];

  const handleAddButtonClick = () => {

    setModalShow(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
    setFormData({
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      station_code: '',
      user_type: 'E'
    });
    setModalSec('');

  };

  const [gridData, setGridData] = useState([]);
  const [stationList, setStationList] = useState([]);
  const fetchStation = async () => {
    try {
      const res = await withRFSToken.post(AIRLINESTATION, { status: 'A' })
        .then(function (res) {
          const innerData = res.data.Rows;
          // setGridData(innerData);
          const transformData = innerData ? innerData.map((item) => ({
            label: item.station_code,
            value: item.station_code
          })) : []
          setStationList(transformData)
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchData = async () => {
    const payload = ruleId ? { rule_id: ruleId } : {}
    try {
      const res = await withRFSToken.post(AIRLINEUSER, payload)
        .then(function (res) {
          // if (res.data.response_code === 200) {
          const innerData = res.data.Rows;
          console.log("🚀 ~ .then ~ innerData:", innerData)
          // const transformedData = innerData ? innerData.map(item => ({
          //   value: item.code,
          //   label: item.code +'-'+ item.name
          // })) : [];    
          setGridData(innerData);
        });
      // } else {
      //   toast.error(res.data.response_msg)
      // }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    if (isMounted.current) return;
    // Call the fetchData function to fetch data from the API
    fetchData();
    fetchStation();
    isMounted.current = true;
  }, []);

  // const fetchDataDetails = async (id) => {
  //   try {
  //     const res = await withRFSToken.post(USERDETAILS, { user_id: id })
  //       .then(function (res) {
  //         const innerData = res.data.data;
  //         console.log("🚀 ~ .then ~ innerData:xxx", innerData)
  //         const userId = innerData.user_id;

  //         const portalAccess = innerData.portal_access;
  //         const portalAccessObject = {};
  //         if (portalAccess) {
  //           portalAccess.forEach((key) => {
  //             portalAccessObject[key] = true;
  //           });
  //           setFormData({
  //             ...innerData,
  //             station_code: innerData.port_code,
  //             portal_access: portalAccessObject
  //           });
  //           handleEditButtonClick(userId);
  //           console.log("🚀 ~ .then ~ portalAccessObject:", portalAccessObject)
  //         }

  //         return portalAccessObject;
  //         // const transformedData = innerData ? innerData.map(item => ({
  //         //   value: item.code,
  //         //   label: item.code +'-'+ item.name
  //         // })) : [];    
  //         // setStationList(innerData);
  //       });

  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };
  const gridRef = useRef(null);
  useEffect(() => {
    // console.log("🚀 ~ ExportActive ~ PPP:", gridData)
    if (gridRef.current) {

      const source = {
        datatype: 'json',
        datafields: [
          { name: 'user_id', type: 'string' },
          { name: 'first_name', type: 'string' },
          { name: 'last_name', type: 'string' },
          { name: 'email', type: 'string' },
          { name: 'user_type', type: 'string' },
          { name: 'status', type: 'string' },
          { name: 'city', type: 'string' },
          { name: 'country', type: 'string' },
          { name: 'postal_code', type: 'string' },
          { name: 'station_code', type: 'string' },
          { name: 'email_status', type: 'string' },
          { name: 'notification_status', type: 'string' },
          { name: 'phone_number', type: 'string' },
        ],
        localdata: gridData,
      };
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      let columns = [];
      if (isModal) {
        columns = [
          // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },filtertype: 'bool',
          // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },

          {
            text: 'Action',
            cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
              console.log('data', data.email_status);

              return '<div class="grid_actions"><img src="' + (data.notification_status === 1 ? BellG : BellR) + '" class="row_bell" /><img src="' + (data.email_status === 1 ? MailG : MailR) + '" class="row_mail" /></div>';
            },
            width: '10%'
          },
          { text: 'First Name', filtertype: 'textbox', datafield: 'first_name', width: '12%', cellclassname: '', },
          { text: 'Last Name', filtertype: 'textbox', datafield: 'last_name', width: '12%', cellclassname: '', },
          { text: 'Email Id', filtertype: 'textbox', datafield: 'email', width: '20%', cellclassname: '', },
          { text: 'Role', filtertype: 'textbox', datafield: 'user_type', width: '10%', cellclassname: '', },
          // { text: 'Status', filtertype: 'textbox', datafield: 'Status', width: '17%', },
          {
            text: 'Status',
            filtertype: 'textbox',
            datafield: 'status',
            width: '10%',
            cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
              // Check the value of the 'Status' field
              // console.log('12', rowdata);

              if (rowdata.status === 'I') {
                // Return HTML with class 'inactive' for 'i' status
                return '<div class="jqx-grid-cell-left-align bookingstatus inactive">To be planned</div>';
              } else if (rowdata.status === 'A') {
                // Return HTML with class 'active' for 'a' status
                return '<div class="jqx-grid-cell-left-align bookingstatus active">Active</div>';
              } else {
                // Return default HTML
                return defaulthtml;
              }
            }
          },
          { text: 'Station', filtertype: 'textbox', datafield: 'station_code', width: '12%' },
          // { text: 'City', filtertype: 'textbox', datafield: 'city', width: '10%' },
          // { text: 'Country', filtertype: 'textbox', datafield: 'country', width: '10  %' },
          // { text: 'Postal Code', filtertype: 'textbox', datafield: 'postal_code', width: '14%' },
        ];
      } else {
        columns = [
          // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },filtertype: 'bool',
          // { text: 'Select', datafield: 'selected', columntype: 'checkbox', width: 50 },

          {
            text: 'Activities',
            cellsrenderer: function () {
              return '<div class="grid_actions"><img src="' + Reset + '" class="row_reset" /><img src="' + edit + '" class="row_edit" /><img src="' + trash + '" class="row_delete" /></div>';
            },
            width: '7%'
          },
          { text: 'First Name', filtertype: 'textbox', datafield: 'first_name', width: '10%', cellclassname: '', },
          { text: 'Last Name', filtertype: 'textbox', datafield: 'last_name', width: '10%', cellclassname: '', },
          { text: 'Email Id', filtertype: 'textbox', datafield: 'email', width: '20%', cellclassname: '', },
          { text: 'Role', filtertype: 'textbox', datafield: 'user_type', width: '10%', cellclassname: '', },
          // { text: 'Status', filtertype: 'textbox', datafield: 'Status', width: '17%', },
          {
            text: 'Status',
            filtertype: 'textbox',
            datafield: 'status',
            width: '9%',
            cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
              // Check the value of the 'Status' field
              // console.log('12', rowdata);

              if (rowdata.status === 'I') {
                // Return HTML with class 'inactive' for 'i' status
                return '<div class="jqx-grid-cell-left-align bookingstatus inactive">To be planned</div>';
              } else if (rowdata.status === 'A') {
                // Return HTML with class 'active' for 'a' status
                return '<div class="jqx-grid-cell-left-align bookingstatus active">Active</div>';
              } else {
                // Return default HTML
                return defaulthtml;
              }
            }
          },
          { text: 'Station', filtertype: 'textbox', datafield: 'station_code', width: '10%' },
          // { text: 'City', filtertype: 'textbox', datafield: 'city', width: '10%' },
          // { text: 'Country', filtertype: 'textbox', datafield: 'country', width: '10  %' },
          // { text: 'Postal Code', filtertype: 'textbox', datafield: 'postal_code', width: '14%' },
        ];
      }


      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        enabletooltips: true,
        editable: false,
        // selectionmode: 'checkbox',
        pageable: true,
        pageSize: 10,
        pagerButtonsCount: 10,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 50,
        columnsheight: 45,
      };


      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      window.$(gridRef.current).on('click', '.row_edit', function (row) {
        const rowDiv = window.$(this).closest('[role="row"]');


        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const id = rowData.user_id
        console.log("🚀 ~ rowDiv:", rowData)
        // fetchDataDetails(id);
        const rowBookingId = rowData.booking_id;
        setModalSec('E');
        setModalShow(true);
        const { user_id, first_name, last_name, email, phone_number, station_code, user_type } = rowData || {};
        setFormData({
          user_id: user_id ?? '',
          first_name: first_name ?? '',
          last_name: last_name ?? '',
          email: email ?? '',
          phone_number: phone_number ?? '',
          station_code: station_code ?? '',
          user_type: user_type === 'User' ? 'E' : 'S'
        });
      });
      window.$(gridRef.current).on('click', '.row_reset', function (row) {
        const rowDiv = window.$(this).closest('[role="row"]');

        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const id = rowData.user_id
        // console.log("🚀 ~ rowDiv:", rowData)
        // fetchDataDetails(id);
        const rowBookingId = rowData.booking_id;
        setModalSec('R');
        setModalShow(true);
        const { user_id, first_name, last_name, email, phone_number, station_code, user_type, password } = rowData || {};
        setFormData({
          user_id: user_id ?? '',
          password: password ?? '',
          user_type: user_type === 'User' ? 'E' : 'S'
        });
      });
      window.$(gridRef.current).on('click', '.row_delete', function (row) {

        const rowDiv = window.$(this).closest('[role="row"]');


        const rowIndex = window.$(rowDiv).attr('row-id');
        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
        const id = rowData.user_id
        setDeleteId(id);
        console.log("🚀 ~ rowDiv:", rowData)

        handleShowConfirmation(deleteRow);
        const rowBookingId = rowData.booking_id;


      });

    }

  }, [gridData]);

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    station_code: '',
    user_type: 'E'
  });



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData((prevData) => ({
        ...prevData,
        portal_access: {
          ...prevData.portal_access,
          [name]: checked
        }
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value
      }));
    }
    // setFormData((prevData) => ({
    //   ...prevData,
    //   // [name]: type == 'checkbox' ? { ...prevData, [value]: checked } : value
    // }));
    // console.log('202', formData);
  };
  const validateFormData = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Function to validate email
    const validateEmail = (email) => {
      return emailRegex.test(email);
    };
    // if (!formData.first_name) {
    //   console.log('Text input is required');
    //   toast.error('First Name must not be blank');
    //   isValid = false;
    // } else if (!formData.last_name) {
    //   console.log('Text input is required');
    //   toast.error('Last Name must not be blank');
    //   isValid = false;
    // } else if (!formData.email) {
    //   console.log('Text input is required');
    //   toast.error('Email must not be blank');
    //   isValid = false;
    // } 
    if (!validateEmail(formData.email)) {
      console.log('Invalid email address');
      toast.error('Invalid email address');
      isValid = false;
    }
    // else if (!formData.phone_number) {
    //   console.log('Text input is required');
    //   toast.error('Phone Number must not be blank');
    //   isValid = false;
    // } else
    //   if (!/^\d{10}$/.test(formData.phone_number)) {
    //     console.log('10');
    //     toast.error('Phone Number must be 10 Digits');
    //     isValid = false;
    //   } 
    else {
      return isValid;
    }
  };
  const handleSubmit = () => {
    
    const stationcode = stationList.find(lst => lst.port_code == formData.station_code);
    // console.log("🚀 ~ handleSubmit ~ stationcode:", stationcode)
    let end_point;
    let payLoad;
    if (modalSec !== 'R') {
      if (!validateFormData()) { return; }
      end_point = AIRLINESAVEUSER;
      // payLoad = formData
    } else {
      end_point = 're-generate-password'
      // payLoad = {user_id: formData.user_id, password: }
    }
    CallApi({
      endPoint: end_point,
      payload: formData,
      onSuccess: (res) => {
        const resCode = res.data.response_code;
        if (resCode === 200) {
          if (modalSec !== 'R') {
            toast.success('User Data Saved Successfully');
            setFormData({ first_name: '', last_name: '', email: '', phone_number: '', station_code: '', user_type: 'E' })
          } else {
            toast.success('Successfull');            
          }
          fetchData();
          handleModalClose();
          setModalSec('');
        } else {
          toast.error(res.data.response_msg)
        }
      },
      onError: (msg) => toast.error(msg)
    });

    // try {
    //   const res = await withRFSToken.post(AIRLINESAVEUSER, formData);
    //   if (res.data.response_code === 200) {

    //     toast.success('User Data Saved Successfully');

    //     setFormData({ first_name: '', last_name: '', email: '', phone_number: '', station_code: '', user_type: 'E' })
    //     fetchData();
    //     handleModalClose();
    //     setModalSec('');
    //   } else {
    //     toast.error(res.data.response_msg);
    //   }

    // } catch (error) {
    //   console.error('Error sending request:', error);
    // }
  };
  const handleEditSubmit = async () => {
    if (validateFormData()) {
      // You can send formData to your API endpoint here
      //   const selectedAccess = Object.entries(formData.portalAccess)
      // .filter(([key, value]) => value)
      // .map(([key]) => key);
      const stationcode = stationList.find(lst => lst.port_code == formData.station_code);
      // console.log("🚀 ~ handleSubmit ~ stationcode:", stationcode)
      const portalAccessArray = Object.keys(formData.portal_access)
        .filter(key => formData.portal_access[key]);

      // Create the final data object for submission
      // const finalData = {
      //   ...formData,
      //   user_id: editId,
      //   // port_address: stationcode.port_address,
      //   // portal_access: portalAccessArray
      // };
      // console.log('fdaa', finalData);
      // try {
      //   const res = await withRFSToken.post(SUBMITLIST, finalData);
      //   console.log("response==>", res.data);
      //   if (res.data.status === 400) {
      //     console.log('www', res.data.message)
      //     toast.error(res.data.message);
      //   } else {
      //     setFormData({ first_name: '', last_name: '', email: '', phone_number: '', station_code: '', })
      //     reloadGrid();
      //     handleModalClose();
      //     setEditId('');
      //   }

      // } catch (error) {
      //   console.error('Error sending request:', error);
      // }

    }

  };
  const handleShowConfirmation = (deleteFunction) => {
    setModalConf(true);
    setDeleteFunction(() => deleteFunction);
  };
  const handleConfirmDelete = () => {
    // deleteRow(gridSelect);
    deleteFunction(deleteId)
    setModalConf(false);
  };

  const handleCancelDelete = () => {
    setDeleteId('')
    setModalConf(false);
  };
  const deleteRow = async (selectedId) => {

    try {
      const res = await withRFSToken.post(AIRLINEREMOVEUSER, { user_id: selectedId });
      if (res.data.response_code == 200) {
        toast.success('User Data Removed Successfully')
        fetchData();
        setDeleteId('');
      } else {
        toast.error(res.data.response_msg);
      }
    } catch (error) {
      console.error('Error sending request:', error);
    }
  };
  const hideToggle = () => {
    setShowHide(!showHide);
  }
  const passwordCheck = (password = '') => ({
    length: password.length >= 5 && password.length <= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  });
  const passwordChecks = passwordCheck(formData.password);

  const passChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }

  return (
    <>
      {/* <div className="">{console.log('formData', formData)}
        {isModal ? '' : <Header page_type='settings' logo_url='/Dashboard' sBackUrl='/Dashboard' />}
        <div className={isModal ? '' : "main-panel"}>

          <div className="row">
            {isModal ? '' : <LeftSettings />} */}
            {console.log("🚀 ~ formData:", formData)}
      {modalConf &&
        <ConfModal
          header='Confirm Delete'
          subHeader='If you proceed with the change, user data will be removed. Are you sure you want to continue?'
          modalConf={handleConfirmDelete}
          closeModal={handleCancelDelete}
          primaryBtn='Yes'
          secondaryBtn='No'
        />
      }
      <div className={isModal ? '' : 'col-9 col-xxl-9 stting_right'}>
        <div className={isModal ? '' : 'settingbg_right'}>
          {isModal ? '' :
            <>
              <h4>User Setting</h4>
              <p>Set your notification preferences for when you are in or away from the dashboard.</p>
              <div className='d-flex justify-content-between'>
                <div>
                  <Button variant="primary createplan" onClick={handleAddButtonClick} >
                    <FontAwesomeIcon icon={faPlus} /> Add User
                  </Button>
                </div>
                <div className='rastatus'>
                  <span>Status : </span>
                  <Form.Select>
                    <option>All</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </Form.Select>
                </div>

              </div>
            </>
          }
          <div ref={gridRef} className='bookinggrid userstting'></div>
        </div>
      </div>
      {/* </div> */}
      <CommonModal
        show={modalShow}
        onHide={handleModalClose}
        title={modalSec == 'E' ? 'Edit User' : modalSec == 'R' ? 'Reset Password' : 'Add User'}
        className='addfrom'
        // onSubmit={handleSubmit}
        footer={
          <>
            {modalSec !== 'R' ?
              <Button variant="primary" onClick={handleSubmit}>
                {modalSec == 'E' ? 'Update' : 'Add'} User
              </Button>
              :
              <div className="d-flex w-50 mx-auto are_bottom">
                <Button variant="secondary" onClick={handleModalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                  Save
                </Button>
              </div>
            }
          </>
        }
      >
        {modalSec !== 'R' &&
          <>
            <Form.Group as={Row} className='mb-2'>
              <Col sm="6">
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" name='first_name' placeholder="First Name" value={formData.first_name} onChange={handleChange} />
              </Col>
              <Col sm="6">

                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" placeholder="Last Name" name='last_name' value={formData.last_name} onChange={handleChange} />

              </Col>
            </Form.Group>

            <Form.Group as={Row} className='mb-2'>
              <Col sm="6">
                <Form.Label>Email id</Form.Label>
                <Form.Control type="text" name='email' placeholder="Email id" value={formData.email} onChange={handleChange} />
              </Col>
              <Col sm="6">
                <Form.Label>Telephone No</Form.Label>
                <Form.Control
                  type="number"
                  maxLength='12'
                  onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }}
                  name='phone_number'
                  value={formData.phone_number}
                  onChange={handleChange}
                  placeholder="Number"
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="dropdown" className='mb-3' as={Row}>
              <Col sm='6'>
                <Form.Label>Select Station</Form.Label>
                {/* <Form.Select aria-label="Default select example" name="station_code" value={formData.station_code} onChange={handleChange}>
                  <option>Select Station</option>
                  {console.log('ddd', stationList)}
                  {stationList && stationList.map((list, index) => (
                    <option key={index} value={list.value}>{list.label}</option>
                  ))} */}
                {/* <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select> */}
                <Select
                  options={stationList}
                  onChange={(selected) => {
                    const updatedData = { ...formData, station_code: selected.value };
                    setFormData(updatedData);
                  }}
                  placeholder="Select Station"
                  className='down_selct'
                  name="station_code"
                  value={stationList.find(option => option.value === formData.station_code)}
                />
              </Col>
              <Col sm='6'>
                <Form.Label>User Role</Form.Label>
                {/* <Form.Select aria-label="Default select example" name="station_code" value={formData.station_code} onChange={handleChange}>
                  <option>Select Station</option>
                  {console.log('ddd', stationList)}
                  {stationList && stationList.map((list, index) => (
                    <option key={index} value={list.value}>{list.label}</option>
                  ))} */}
                {/* <option value="1">One</option>
                  <option value="2">Two</option>
                  <option value="3">Three</option>
                </Form.Select> */}
                <Select
                  options={userRole}
                  onChange={(selected) => {
                    const updatedData = { ...formData, user_type: selected.value };
                    setFormData(updatedData);
                  }}
                  placeholder="Select Station"
                  className='down_selct'
                  name="user_type"
                  value={userRole.find(option => option.value === formData.user_type)}
                />
              </Col>
            </Form.Group>
          </>
        }
        {modalSec === 'R' &&
          <>
            <Form.Group className='mb-2'>
              <div className='d-flex justify-content-between'>
                <Form.Label>Password <span>*</span></Form.Label>
                <img src={showHide ? hide : view} style={{ height: '20px' }} className="passwrd_view" onClick={hideToggle} />
              </div>
              <Form.Control
                type={showHide ? 'text' : 'password'}
                name='password'
                value={formData.password}
                onChange={passChange}
                placeholder="Password"
              />
              <h4 className='mt-4'>Password must include the following: </h4>
              <ul>
                <li><img src={passwordChecks.length ? Tick : Cross} /> Your password must be 5-8 characters long.</li>
                <li><img src={passwordChecks.upper ? Tick : Cross} /> An uppercase character</li>
                <li><img src={passwordChecks.lower ? Tick : Cross} /> A lower case character</li>
                <li><img src={passwordChecks.number ? Tick : Cross} /> A number</li>
                <li><img src={passwordChecks.special ? Tick : Cross} /> A special character</li>
              </ul>
            </Form.Group>
          </>
        }
      </CommonModal>

      {/* <Modal className='raintrac' show={showConfirmation} onHide={() => setModalConf(false)}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h2>Confirm Delete</h2>
          <p>If you proceed with the change, user data will be removed.
            Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDelete}>
            No
          </Button>
          <Button variant="primary" onClick={handleConfirmDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal> */}
      {/* </div>
      </div> */}
    </>
  )
}

export default UserSettings;